export enum EMQ_AGGREGATED_STATUS {
  HEALTHY = 'healthy',
  WARNING = 'warning',
  CRITICAL = 'critical',
  UNKNOWN = 'unknown',
  NOT_CONFIGURED = 'not_configured',
}
